<template>
  <div class="loadingStatus" role="alert" aria-live="assertive">
    <span v-if="isLoading" class="visually-hidden">{{ textLoading }}</span>
    <span class="error" v-else-if="error">{{ textError }}</span>
    <span v-else class="visually-hidden">{{ textLoaded }}</span>
  </div>

  <div v-if="isLoading" class="loaderContainer d-flex justify-content-center">
    <div class="loader"></div>
  </div>
</template>

<script>
export default {
  name: "Spinner",
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
    error: {
      type: Boolean,
      required: true,
    },
    textLoading: {
      type: String,
      required: true,
    },
    textError: {
      type: String,
      required: true,
    },
    textLoaded: {
      type: String,
      required: true,
    },
  },
};
</script>
